import getSubscribedPaths from "./getSubscribedPaths";
import type { UnsubsByPath } from "./types";

export default function getUnusedPaths<
  PathDefinition extends { onlyOnce?: boolean },
>(
  unsubsByPath: UnsubsByPath,
  newDefinitions: PathDefinition[],
  // Matches getMissingDefinitions: callers build paths from the path-identifying
  // fields only, so accepting `Omit<…, "onlyOnce">` keeps generic inference
  // working for hosts that enable strictFunctionTypes.
  definitionToPath: (definition: Omit<PathDefinition, "onlyOnce">) => string,
) {
  const existingPaths = getSubscribedPaths(unsubsByPath);
  const liveDefinitions = newDefinitions.filter(({ onlyOnce }) => !onlyOnce);

  // onlyOnce-only calls still go through multiSubscribe for one-shot reads, but
  // they do not declare a live set — so they must not prune existing listeners.
  // An empty `newDefinitions` array (intentional clear / disable) still unsubs all.
  if (liveDefinitions.length === 0 && newDefinitions.length > 0) {
    return [];
  }

  const newPaths = new Set(liveDefinitions.map(definitionToPath));

  const unusedPaths = existingPaths.filter(
    (existingPath) => !newPaths.has(existingPath),
  );

  return unusedPaths;
}
